import { ListaEventoElement } from 'models/ListaEventoElement';

interface TableState {
  rows: Array<ListaEventoElement>;
  page: number;
  count: number;
}

type TableActionType = 'setRows' | 'setPage' | 'setCount';

interface TableAction {
  type: TableActionType;
  value: any;
}

export const tableInitialState: TableState = {
  rows: [],
  page: 0,
  count: 0,
};

export const tableReducer = (state: TableState, action: TableAction): TableState => {
  switch (action.type) {
    case 'setRows':
      return { ...state, rows: action.value };
    case 'setPage':
      return { ...state, page: action.value };
    case 'setCount':
      return { ...state, count: action.value };
    default:
      return state;
  }
};
